import { Sidebar } from "flowbite-react";
import { HiUser, HiChartPie, HiDatabase, HiInbox, HiLogout} from "react-icons/hi";
import { Link } from "react-router-dom";


function SideBar() {
  return (
    <Sidebar className="h-lvh" aria-label="Sidebar with content separator example">
    <Sidebar.Items>
      <Sidebar.ItemGroup>
        <Sidebar.Item as={Link} to="/admin/dashboard/uploadimage" icon={HiInbox}>
          UploadImage
        </Sidebar.Item>
        <Sidebar.Item as={Link} to="/admin/dashboard/manageimage" icon={HiDatabase}>
          ManageImage
        </Sidebar.Item>
        <Sidebar.Item as={Link} to="/rajasthanigallery" icon={HiChartPie}>
          RajasthaniGold
        </Sidebar.Item>
        <Sidebar.Item as={Link} to="/AntiqueGoldGallery" icon={HiChartPie}>
        AntiqueGold
        </Sidebar.Item>
        <Sidebar.Item as={Link} to="/DesiGallery" icon={HiChartPie}>
        MarwadiGold
        </Sidebar.Item>
        <Sidebar.Item as={Link} to="/SilverGallery" icon={HiChartPie}>
          SilverJewellery
        </Sidebar.Item>
        <Sidebar.Item as={Link} to="/admin/profile" icon={HiUser}>
          UpdateAdmin
        </Sidebar.Item>
      </Sidebar.ItemGroup>
      <Sidebar.ItemGroup>
        <Sidebar.Item as={Link} to="/admin/logout" icon={HiLogout}>
          Log Out 
        </Sidebar.Item>
      </Sidebar.ItemGroup>
    </Sidebar.Items>
  </Sidebar>
  )
}

export default SideBar
